export enum ContractorInformationLinkButtonsLabel {
  TermsOfUse = 'Terms of Use',
  ESignConsentDisclosure = 'E-Sign Consent/Disclosure',
  AcknowledgementAndConsent = 'Acknowledgement and Consent',
}
